// extracted by mini-css-extract-plugin
module.exports = {"credentials":"styles_credentials__ffSXX","copyright":"styles_copyright__Q3lnp","social":"styles_social__G740z","socialItem":"styles_socialItem__rLU5b"};